import Box, { type IBoxProps } from '@atoms/Box/Box';
import { clsx } from 'clsx';
import './DocumentBox.scss';

/** Единая рамка содержимого для секций карточки документа. */
const DocumentBox = ({ className, ...props }: IBoxProps) => (
    <Box {...props} className={clsx('document-box', className)} />
);

export default DocumentBox;
